import Layout from '@/layout'

export default [
  {
    path: '/degree',
    name: 'Degree',
    component: Layout,
    redirect: '/degree/degreeSignUp',
    meta: { title: '学历管理', icon: 'el-icon-s-order' },
    children: [
      {
        path: 'dict',
        name: 'DictManage',
        component: () => import('@/views/degree/DictManage/index.vue'),
        meta: { title: '字典管理' },
      },
      {
        path: 'degreeSignUp',
        name: 'DegreeSignUp',
        component: () => import('@/views/degree/DegreeSignUp/index.vue'),
        meta: { title: '学历报名管理' },
      },
      {
        path: 'degreeSignUp/detail',
        name: 'DegreeSignUpDetail',
        component: () => import('@/views/degree/DegreeSignUp/detail.vue'),
        meta: { title: '报名资料' },
        hidden: true,
      },
      {
        path: 'degreeSignUp/upload',
        name: 'DegreeSignUpUpload',
        component: () => import('@/views/degree/DegreeSignUp/upload.vue'),
        meta: { title: '上传资料' },
        hidden: true,
      },
    ],
  },
]
